var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageTextCircle01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6649 12.6667H15.9982M10.6649 17.3333H19.9982M16.6649 26.6667C22.9241 26.6667 27.9982 21.5926 27.9982 15.3333C27.9982 9.07411 22.9241 4 16.6649 4C10.4056 4 5.33153 9.07411 5.33153 15.3333C5.33153 16.6 5.53933 17.8181 5.92269 18.9555C6.06696 19.3835 6.13909 19.5975 6.1521 19.7619C6.16495 19.9243 6.15524 20.0381 6.11507 20.1959C6.07439 20.3558 5.98459 20.522 5.80499 20.8544L3.62411 24.8911C3.31303 25.4669 3.15749 25.7548 3.1923 25.977C3.22262 26.1706 3.33653 26.341 3.50376 26.443C3.69577 26.5601 4.02126 26.5265 4.67225 26.4592L11.5003 25.7534C11.7071 25.732 11.8104 25.7213 11.9047 25.7249C11.9974 25.7284 12.0628 25.7371 12.1532 25.758C12.2451 25.7792 12.3606 25.8237 12.5917 25.9127C13.8558 26.3997 15.2292 26.6667 16.6649 26.6667Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageTextCircle01);
export default __webpack_public_path__ + "static/media/message-text-circle-01.1705fc2bcf6186cc08b36e83637921fc.svg";
export { ForwardRef as ReactComponent };